import { TemplateElement, html, defineElement, classMap } from '@webtides/element-js';
import style from './author-chip.css';

/**
 * @property {AuthorProperties} author
 * @property {'sm' || 'md'} size
 */
export default class AuthorChip extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            author: null,
            size: 'sm',
        };
    }

    get name() {
        return `${this.author?.firstName || ''} ${this.author?.lastName || ''}`;
    }

    template() {
        const anchorClasses = {
            'gap-4': this.size === 'sm',
            'gap-16': this.size === 'md',
        };

        const imageClasses = {
            'size-24': this.size === 'sm',
            'size-[60px]': this.size === 'md',
        };

        const textClasses = {
            'fix-body3': this.size === 'sm',
            'fix-title3-medium': this.size === 'md',
        };

        return html`
            <a
                href="${this.author?.link}"
                class="group inline-flex flex-row items-center w-fit ${classMap(anchorClasses)}"
            >
                <img
                    loading="lazy"
                    class="image aspect-square rounded-full object-cover ${classMap(imageClasses)}"
                    src="${this.author?.image?.src ?? ''}"
                    srcset="${this.author?.image?.srcset ?? ''}"
                    sizes="${this.size === 'sm' ? '24px' : '60px'}"
                    alt="${this.author?.image?.altText ?? ''}"
                />
                <div class="w-fit text-green-medium group-hover:text-green-dark ${classMap(textClasses)}">
                    ${this.name}
                </div>
            </a>
        `;
    }
}

defineElement('mb-author-chip', AuthorChip);
